export default "__VITE_ASSET__Ca1kax9z__"